import React, { useState } from "react";
import "./ContactSection.css";
import patternimg from "../assets/patternimg.png";
import avatar from "../assets/avatar.png";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      alert("Please fill required fields");
      return;
    }

    setSubmitting(true);

    try {
      const res = await fetch(
        "https://www.cmgroupofcompanies.com/Mail/contact.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await res.json();

      if (res.ok) {
        alert("✅ Thank you! We’ll contact you shortly.");
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      } else {
        alert(data.error || "Failed to send message");
      }
    } catch (err) {
      alert("Something went wrong. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="contact-section">
      <img src={patternimg} alt="bg effect" className="contact-pattern" />

      <div className="contact-container">
        {/* Left */}
        <div className="contact-left">
          <h2 className="contact-title">
            We’d love to <br /> hear from you.
          </h2>

          <p className="contact-text">
            Connect with <strong>CM Green Energy India Pvt. Ltd.</strong> for
            project inquiries, renewable energy solutions, collaborations, or
            support.
          </p>

          <div className="contact-call">
            <img src={avatar} alt="profile" className="contact-avatar" />
            <div>
              <p className="contact-call-label">Call us directly</p>
              <p className="contact-call-number">+91 99446 62747</p>
            </div>
          </div>
        </div>

        {/* FORM */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">ENTER YOUR NAME*</label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              placeholder="What's your good name?"
            />
          </div>

          <div className="form-group">
            <label className="form-label">EMAIL ADDRESS*</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your email address"
            />
          </div>

          <div className="form-group">
            <label className="form-label">PHONE NUMBER</label>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">SUBJECT</label>
            <input
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-group form-full">
            <label className="form-label">YOUR MESSAGE*</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-input"
              placeholder="Describe about your project"
            />
          </div>

          <p className="form-note">
            We will never collect information without your consent.
          </p>

          <button className="form-button" disabled={submitting}>
            {submitting ? "Sending..." : "Submit request"}
          </button>
        </form>
      </div>
    </section>
  );
}
